import LoadingPage from './LoadingPage.vue';

const Plugin = function Plugin(Vue) {
  this.Vue = Vue;
  this.mounted = false;
  this.$root = {};
};

Plugin.prototype.mountIfNotMounted = function mountIfNotMounted() {
  if (this.mounted === true) return;

  this.$root = (() => {
    const LoadingPageConstructor = this.Vue.extend(LoadingPage);
    const node = document.createElement('div');
    if (document.querySelector('#console')) {
      document.querySelector('#console').insertAdjacentElement('beforebegin', node);
    } else {
      document.querySelector('#app').appendChild(node);
    }

    return new LoadingPageConstructor().$mount(node);
  })();

  this.mounted = true;
};

Plugin.prototype.open = function open() {
  this.mountIfNotMounted();
  this.$root.setShow(true);
};

Plugin.prototype.close = function close() {
  this.mountIfNotMounted();
  this.$root.setShow(false);
};

Plugin.install = function install(vue) {
  const Vue = vue;
  Vue.loadingPage = new Plugin(vue);
  Vue.prototype.$loadingPage = Vue.loadingPage;
};

export default Plugin;
